import Quotation from '../../api/quotation';
import types from '../mutation-types';

const state = {
    plan_quotations: [],
    fipes: [],
};

export const getters = {
    getPlanQuotations(_state) {
      return _state.plan_quotations;
    },
    getFipes(_state) {
        return _state.fipes;
    },
};

export const actions = {
    async getOrCreateCompanyQuotation({ commit }, payload){
        try {
            const response = await Quotation.getCompanyByCnpj(payload.cnpj);
            return response.data?.id;
        } catch (err) {
            const response = await Quotation.createCompany(payload);
            return response.data?.id;

        }
    },

    async createPlanQuotation({ commit }, payload){
        try {
            const response = await Quotation.createPlanQuotation(payload);
            commit(types.ADD_PLAN_QUOTATION, response.data);
            return response.data
        } catch (err) {
            throw new Error(err);

        }
    },


    async getPlanQuotationByCompany({ commit }, client_id){
        try {
            commit(types.CLEAR_PLAN_QUOTATIONS);
            const response = await Quotation.getPlanQuotationByCompany(client_id);
            commit(types.SET_PLAN_QUOTATIONS, response.data);
            commit(types.ADD_FIPES_FROM_QUOTATIONS, response.data);
            return response.data;
        } catch (err) {
            throw new Error(err);
        }
    },

    async updatePlanQuotation({ commit }, payload){
        try {
            const response = await Quotation.updatePlanQuotation(payload);
            commit(types.EDIT_PLAN_QUOTATION, response.data);
            return response.data
        } catch (err) {
            throw new Error(err);

        }
    },

        
    async deletePlanQuotation({ commit }, plan_id) {
        try {
            const response = await Quotation.deletePlanQuotation(plan_id);
            commit(types.DELETE_PLAN_QUOTATION, plan_id);
            return response.data;
        } catch (err) {
            throw new Error(err);
        }
    },


    async createFipe({ commit }, payload){
        try {

            if(payload.type == 'manual'){
                const response = await Quotation.createFipe(payload);
                response.data.plan_name = payload.plan_name;
                response.data.plan_id = payload.plan_id;
                response.data.fipeMinimo = payload.fipeMinimo
                response.data.fipeMaximo = payload.fipeMaximo
                response.data.preco = payload.preco
                commit(types.ADD_FIPE, response.data);
                return response.data
            }

            const response = await Quotation.createMultipleFipe(payload);
            response.data.plan_name = payload.plan_name;
            response.data.plan_id = payload.plan_id;

            commit(types.ADD_FIPE_MULTIPLE, response.data);
            return response.data
        } catch (err) {
            throw new Error(err);

        }
    },

    async deleteFipe({ commit }, fipe_id) {
        try {
            const response = await Quotation.deleteFipe(fipe_id);
            commit(types.DELETE_FIPE, fipe_id);
            return response.data;
        } catch (err) {
            throw new Error(err);
        }
    },

    async updateFipe({ commit }, payload){
        try {
            const response = await Quotation.updateFipe(payload);
            commit(types.EDIT_FIPE, response.data);
            return response.data
        } catch (err) {
            throw new Error(err);

        }
    },
    cleanDataQuotation({ commit }){
        commit(types.CLEAN_DATA_QUOTATIONS);
    },
    
}

export const mutations = {
    [types.ADD_PLAN_QUOTATION](state, data) {
        state.plan_quotations.push(data);
    },
    [types.SET_PLAN_QUOTATIONS](state, data) {
        state.plan_quotations = data;
    },

    [types.CLEAR_PLAN_QUOTATIONS](state) {
        state.plan_quotations = []
    },
    [types.DELETE_PLAN_QUOTATION](state, plan_id) {
        state.plan_quotations = state.plan_quotations.filter(kf => kf.id !== plan_id);
        state.fipes  = state.fipes.filter(fipe => fipe?.plan_id !== plan_id);
    },
    [types.EDIT_PLAN_QUOTATION](state, data) {
        const index = state.plan_quotations.findIndex(
          plan => plan.id === data.id
        );
        if (index !== -1) {
          state.plan_quotations.splice(index, 1, data);
        }
    },

    [types.ADD_FIPE](state, data) {
        state.fipes.push({...data, plan_name: data.plan_name});
    },
    [types.ADD_FIPE_MULTIPLE](state, data) {
        data.forEach(fipe => {
            const exists = state.fipes.some(existingFipe => existingFipe.id === fipe.id);
            if (!exists) {
                state.fipes.push({...fipe, plan_name: data.plan_name});
            }
        });
    },

    [types.ADD_FIPES_FROM_QUOTATIONS](state, quotations) {
        quotations.forEach(quotation => {
            quotation.fipes.forEach(fipe => {
                const exists = state.fipes.some(existingFipe => existingFipe.id === fipe.id);
                if (!exists) {
                    state.fipes.push({...fipe, plan_name: quotation.nome, plan_id: quotation.id});
                }
            });
        });
    },

    [types.DELETE_FIPE](state, fipe_id) {
        state.fipes = state.fipes.filter(kf => kf.id !== fipe_id);
    },

    [types.EDIT_FIPE](state, data) {
        const index = state.fipes.findIndex(
          fipe => fipe.id === data.id
        );
        if (index !== -1) {
          state.fipes.splice(index, 1, data);
        }
    },
    [types.CLEAN_DATA_QUOTATIONS](state){
        state.plan_quotations = [];
        state.fipes = [];
    }
}

export default {
    actions,
    state,
    getters,
    mutations,
};